import api from "../../index";

export const GetAllPaymentGatwaysApi = (params) => api.get(`PaymentGateway/PaymentGatways?${params}`);
export const UpdatePaymentGatwayStatusApi = (PaymentGatewayId,params) => api.patch(`PaymentGateway/UpdatePaymentGatewayStatus/${PaymentGatewayId}?${params}`);
export const UpdategetwayApi = (data,id) => api.put(`PaymentGateway/Update-PaymentGetwayById/${id}?${data}`,);
export const GetAllCountryApi = () => api.get('DropDown/GetAll-Country');